module.exports = __webpack_public_path__ + "1c349b092098525dbcf68be61fd6b150.png";